import { useEffect, useMemo } from 'react';

import { useGetDocumentFile } from '@area-restrita/api-client/endpoints/document-access/document-access.gen';

export const useDocumentFile = (publicId: string) => {
  const { data, isLoading, error } = useGetDocumentFile(publicId);

  const { objectUrl, contentType, filename } = useMemo(() => {
    if (!data) return {};

    return {
      objectUrl: window.URL.createObjectURL(data),
      contentType: data.type,
      filename: extractFilenameFromBlob(data),
    };
  }, [data]);

  useEffect(() => {
    return () => {
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    };
  }, [objectUrl]);

  return {
    objectUrl,
    contentType,
    filename,
    isLoading,
    error,
  };
};

function extractFilenameFromBlob(blob: Blob): string | null {
  const contentDisposition = (blob as any).contentDisposition;
  if (!contentDisposition) return null;
  const match = contentDisposition.match(/filename="?([^"]+)"?/);
  return match ? match[1] : null;
}
